import {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";

import image8 from "../../../../assets/images/Blog23/image2 oil shock returns.png";

import image17 from "../../../../assets/images/Blog23/image4 CB meetings this week.png";
import image19 from "../../../../assets/images/Blog23/image31 fed expected to do more later.png";
import image51 from "../../../../assets/images/Blog23/image28 tresuries yield not supporting $.png";
import image18 from "../../../../assets/images/Blog23/image1 trump at G7 no co-ordination.png";

import image21 from "../../../../assets/images/Blog23/image21 CPI presure waning.png";
import image22 from "../../../../assets/images/Blog23/image22 US core CPI weakness.png";

import image101 from "../../../../assets/images/Blog23/image9 SPX breadth l_t hanging on.png";
import image102 from "../../../../assets/images/Blog23/image44 nas100 is the top in_.png";
import image103 from "../../../../assets/images/Blog23/image33 gold risk off not oil.png";
import image104 from "../../../../assets/images/Blog23/image24 CSI v FRBNY inflation.png";
import image105 from "../../../../assets/images/Blog23/image20 equity positioning rollover to come_.png";
import image106 from "../../../../assets/images/Blog23/image3 week ahead by day.png";
import image107 from "../../../../assets/images/Blog23/image19 don't fight the buyback.png";

import BlogImagePopper from "./BlogImageLarge";

const Blog23 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – June 16, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p>
          Markets retreat as geopolitics flare, Fed and SNB rate moves loom, and equity breadth collapses. Here's your full macro rundown, technical setups, and trading forecast for the week ahead.
        </p>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "24px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Setting the Stage: Markets on Edge, Not in Panic (Yet)
              </p>
              <p>Last week, markets stared down a textbook geopolitical risk event—and flinched. On Friday, major indices posted their worst day in weeks:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">S&P 500</span>: -1.13%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Dow Jones</span>: -1.79%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Nasdaq 100</span>: -1.29%
                  </p>
                </li>
              </ul>

              <p>
                The trigger? Israeli military strikes on Iranian nuclear facilities, exactly 60 days after Tehran blew past the U.S. dismantling deadline. But unlike past cycles, the market didn’t go
                full panic mode. Safe-haven plays like the U.S. dollar and Treasuries didn’t catch meaningful bids. .
              </p>
              <p>
                Instead, capital rotated into <span className="highlightedText">Gold</span>, which remains the primary recipient of geopolitical hedging flows, and Oil, which spiked on fears around
                the Strait of Hormuz—a corridor for nearly 20% of global oil supply.
              </p>
              <div className="relatedImg">
                <img
                  src={image8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p>
                Equity sentiment was already showing signs of fatigue. Breadth had narrowed, insiders like Meta’s Zuckerberg were selling, and institutional flows were lightening up. The market wasn't
                caught off guard—it was already nervous.
              </p>
              <div className="relatedImg">
                <img
                  src={image18}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image18)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Central Banks, CPI Surprise & De-Dollarisation</p>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Inflation: Cool as a Cucumber
              </p>
              <p>The May CPI release was a macro jaw-dropper. No analyst in the Bloomberg survey saw it coming:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Core CPI</span>: -1.13%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Supercore CPI (ex-shelter services)</span>: -1.79%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Shelter costs continue to ease, with recreation and travel showing cyclically soft prints.</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                It looked like a pre-pandemic inflation report—low, boring, and oddly comforting. However, analyst warn that May’s data only priced in half of the new tariff impacts. The full
                inflationary wave (if any) may show up next month
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Central Banks Galore</p>
              <p>This week is packed:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Federal Reserve (Wed)</span>: Expected to hold, but the Summary of Economic Projections (Dot Plot) will be the showstopper. Markets want a dovish
                    tilt, especially post-CPI.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SNB (Thu)</span>: A cut to 0% is on deck. Swiss inflation is tame, the franc is too strong, and short-term yields are already sub-zero.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">BOE, BOJ, Riksbank</span>: All are expected to hold, but forward guidance matters. The BOE faces stagflation risks, while the BOJ must address a
                    hawkish market despite economic softness.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              {/*  */}

              <p className="highlightedBoldText">De-Dollarisation & Flow Quirks</p>
              <p>Despite strong U.S. yields, the dollar isn’t acting like a classic haven. Global capital continues to diversify:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">$15B </span>into bonds
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">$1.7B </span>into gold
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">$10B </span>out of equities
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                {" "}
                <div className="relatedImg">
                  <img
                    src={image51}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image51)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Rate differentials aren’t luring dollar bulls, possibly due to de-dollarisation flows globally. Powell knows he’s fighting more than just inflation now—he’s fighting a confidence war
                in a bifurcated macro regime.
              </p>

              <hr className="divisionLine" />
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown</p>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Market Internals Breaking Down
              </p>
              <p>Market strength is thinning:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">S&P 500</span>: 97 new highs vs 242 new lows (net -145)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Nasdaq 100</span>: Short-term momentum cracked; only 22.7% of components above 5-day MA
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Russell 1000</span>: Worst breadth print—net -400 on 5-day highs vs lows
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image101}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image101)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image102}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image102)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>This isn’t a “collapse” scenario yet. But it’s the kind of internal breakdown that usually precedes a corrective phase, especially with institutions exiting weaker names.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: CPI Eases, Risk Rises</p>
              <p>
                Markets were riding high until Friday’s geopolitical jolt: Israel hit Iranian nuclear infrastructure, escalating tensions but stopping short of full panic. Gold rallied, equities
                dropped, and bonds shrugged—a curious mix of risk-off behaviour.
              </p>
              <div className="relatedImg">
                <img
                  src={image103}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image103)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p className="highlightedText">
                Meanwhile, May’s <span>CPI print shocked to the downside</span>:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Core CPI</span>: +0.13% MoM
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Supercore inflation</span>: just +0.06%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Shelter and cyclical services cooled notably</p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image104}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image104)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Flows showed increasing caution:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>$10B out of stock</p>
                </li>
                <li className="themesPointer">
                  <p>$15B into bonds</p>
                </li>
                <li className="themesPointer">
                  <p>Institutions dumped U.S. equities for a fifth straight week—the worst stretch since 2008.</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image105}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image105)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>On the micro front, Adobe beat but flagged AI concerns, while Amazon and Walmart stirred fintech disruption with talk of stablecoins</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Week Ahead: “Central Banks, CPI Waves, and Retail Realities</p>
              <p>A massive week for macro watchers as five major central banks speak, CPI fallout is measured, and retail sales take the spotlight.</p>

              <p className="highlightedText">Monday, June 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CHF PPI could confirm SNB’s need to cut</p>
                </li>
                <li className="themesPointer">
                  <p>China Retail Sales, Industrial Production & Fixed Asset Investment</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone Q1 wages and labour costs</p>
                </li>
                <li className="themesPointer">
                  <p>OPEC Monthly Report</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image106}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image106)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Tuesday, June 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>BOJ Rate Decision (hold expected)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Retail Sales + Import/Export Prices</p>
                </li>
                <li className="themesPointer">
                  <p>Industrial Production & Business Inventories</p>
                </li>
                <li className="themesPointer">
                  <p>German ZEW Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Villeroy & Centeno speak</p>
                </li>
              </ul>
              <p>Watch: Retail sales closely—CPI showed weak goods inflation, but tariffs may now bite.</p>

              <p className="highlightedText">Wednesday, June 18</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>GBP CPI/RPI, Eurozone CPI, Sweden Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Building Permits, Housing Starts, Atlanta GDPNow</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Rate Decision & Dot Plot (SEP) – main macro event</p>
                </li>
                <li className="themesPointer">
                  <p>Powell Press Conference</p>
                </li>
                <li className="themesPointer">
                  <p>30Y German Bund Auction</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Thursday, June 19 (U.S. Juneteenth Holiday)</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CHF Rate Decision & Press Conference</p>
                </li>
                <li className="themesPointer">
                  <p>BOE Rate Decision & Minutes</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Lagarde, Villeroy, De Guindos speak</p>
                </li>
                <li className="themesPointer">
                  <p>NZ GDP, AUD Employment, CHF Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. jobless claims (released early due to holiday)</p>
                </li>
              </ul>
              <p>SNB likely to cut to 0%; BOE faces a stagflation trap</p>

              <p className="highlightedText">Friday, June 20</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>UK Retail Sales, German PPI, Japan CPI</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Philly Fed & Leading Index</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone Consumer Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>BOJ Ueda speaks, ECB Bulletin release</p>
                </li>
              </ul>
              <p>Final inflation and sentiment readings to close a heavy macro week</p>
            </div>
          </div>
        </div>

        {/*  */}

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: “Short-Term Pullback Before the Next Impulse”</p>
              <p>
                Markets are in transition, not crisis. The soft CPI may buy time, but risks remain stacked: geopolitical flashpoints, equity breadth breakdown, and CBs trapped between slowflation and
                reflation.
              </p>

              <p className="highlightedText">Our stance:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Hold core <span>Tech</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Stay long, <span>Gold</span> especially if conflict escalates.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Add to <span>Defence stocks</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Keep cash for dips—expect a 2–3% retracement ahead.</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image105}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image105)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image107}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image107)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1Xn4FVfQL9iVwNKeqWRY888SssHGCpQrPFGTf0UujoYg/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog23;
